import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { ShopRoutes } from '../shop/shop.routes';
//import { MailAlertRoutes } from '../mail-alert/mail-alert.routes';
import { FavoritesRoutes } from '../favorites/favorites.routes';

@NgModule({
  imports: [
    ShopRoutes,
    FavoritesRoutes,
    //MailAlertRoutes
  ],
  exports: [
    UIRouterModule
  ]
})

export class RoutingModule {
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/routing/routing.module.ts